<template>
  <div class="dish-photo">
    <dish-image
      :src="value || ''"
      :alt="alt"
      contain
    ></dish-image>

    <div class="d-flex align-center flex-wrap mt-4">
      <v-btn
        color="primary"
        outlined
        class="me-3 mb-2"
        @click="$refs.file.click()"
      >
        <v-icon
          size="18"
          class="me-1"
        >
          {{ icons.mdiCloudUploadOutline }}
        </v-icon>
        <span>Загрузить фото</span>
      </v-btn>
      <v-btn
        color="error"
        outlined
        class="mb-2"
        :disabled="!value"
        @click="remove"
      >
        Удалить
      </v-btn>
    </div>
    <div class="text-caption text--secondary">
      Выберите PNG файл
    </div>

    <input
      ref="file"
      type="file"
      accept=".png"
      hidden
      @change="onFileChange"
    />
  </div>
</template>

<script>
import { mdiCloudUploadOutline } from '@mdi/js'
import DishImage from './dish-image.vue'

export default {
  name: 'DishPhoto',
  components: { DishImage },
  props: {
    value: { type: String, default: '' },
    alt: { type: String, default: '' },
  },
  data: () => ({
    icons: { mdiCloudUploadOutline },
  }),
  methods: {
    onFileChange(event) {
      const file = event.target.files[0]

      if (!file) return

      this.$emit('formData-updated', file.slice(0, file.size, file.type))

      const reader = new FileReader()

      reader.onloadend = () => this.$emit('input', reader.result)
      reader.readAsDataURL(file)
    },
    remove() {
      this.$refs.file.value = null
      this.$emit('input', '')
      this.$emit('file-removed')
    },
  },
}
</script>
